"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const framer_motion_1 = require("framer-motion");
const lucide_react_1 = require("lucide-react");
const useStore_1 = require("../../store/useStore");
require("./LockScreen.css");
const LockScreen = () => {
    const { currentUser, unlockApp, isLocked } = (0, useStore_1.useStore)();
    const [pin, setPin] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)(false);
    const inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (isLocked && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isLocked]);
    if (!isLocked || !currentUser)
        return null;
    const handlePinChange = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 6);
        setPin(value);
        setError(false);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (pin.length < 4)
            return;
        const success = unlockApp(pin);
        if (!success) {
            setError(true);
            setPin('');
            if (inputRef.current)
                inputRef.current.focus();
        }
    };
    return ((0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: isLocked && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { className: "lock-screen-overlay", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0, backdropFilter: 'blur(0px)' }, children: (0, jsx_runtime_1.jsxs)(framer_motion_1.motion.div, { className: "lock-screen-container", initial: { scale: 0.9, y: 20 }, animate: { scale: 1, y: 0 }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "lock-avatar-container", children: [currentUser.avatar ? ((0, jsx_runtime_1.jsx)("img", { src: currentUser.avatar, alt: "Avatar", className: "lock-avatar" })) : ((0, jsx_runtime_1.jsx)("div", { className: "lock-avatar-fallback", children: (currentUser.displayName || currentUser.username).charAt(0).toUpperCase() })), (0, jsx_runtime_1.jsx)("div", { className: "lock-icon-badge", children: error ? (0, jsx_runtime_1.jsx)(lucide_react_1.XCircle, { size: 18, color: "#ef4444" }) : (0, jsx_runtime_1.jsx)(lucide_react_1.Lock, { size: 18 }) })] }), (0, jsx_runtime_1.jsx)("h2", { className: "lock-welcome", children: "Tekrar Ho\u015F Geldin" }), (0, jsx_runtime_1.jsxs)("p", { className: "lock-username", children: ["@", currentUser.username] }), (0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, className: "lock-form", children: [(0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { className: `pin-input-wrapper ${error ? 'error' : ''}`, animate: error ? { x: [-10, 10, -10, 10, 0] } : {}, transition: { duration: 0.4 }, children: (0, jsx_runtime_1.jsx)("input", { ref: inputRef, type: "password", className: "pin-input", placeholder: "PIN Girin (4-6 haneli)", value: pin, onChange: handlePinChange, maxLength: 6 }) }), (0, jsx_runtime_1.jsx)("p", { className: "lock-hint", children: "Uygulaman\u0131n kilidini a\u00E7mak i\u00E7in PIN'inizi girin." })] })] }) })) }));
};
exports.LockScreen = LockScreen;
